import * as React from 'react';
const h = React.createElement;

export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const Switch: React.FC<SwitchProps> = function Switch(props) {
  const { checked = false, onChange, disabled = false, className = '' } = props;
  return h(
    'button',
    {
      type: 'button',
      role: 'switch',
      'aria-checked': checked,
      disabled,
      className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 ${checked ? 'bg-primary-600' : 'bg-dark-600'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`,
      onClick: () => {
        if (!disabled && onChange) onChange(!checked);
      },
    },
    h('span', {
      className: `inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 shadow ${checked ? 'translate-x-6' : 'translate-x-1'}`,
    }),
  );
};

export { Switch };
